var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificCheckout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFF8E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1150_13468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1150_13468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6867 6.99277C12.9775 6.99277 12.2647 6.98904 11.5556 6.99277C11.1973 6.99277 11.0144 7.19058 11.0032 7.54514C10.9957 7.73921 11.0032 7.93702 10.9696 8.12736C10.9248 8.36249 10.7307 8.48939 10.4882 8.48565C10.2605 8.48565 10.0627 8.35503 10.0291 8.13109C9.93205 7.48542 9.96564 6.86587 10.4993 6.38442C10.7755 6.13809 11.1002 6 11.4772 6C13.2985 6 15.1161 6 16.9374 6C17.5868 6 18.0011 6.42547 18.0011 7.07488C18.0011 10.0271 18.0011 12.9792 18.0011 15.9314C18.0011 16.4539 17.7548 16.7973 17.2546 16.9652C16.3029 17.2862 15.3512 17.6034 14.3958 17.917C13.6381 18.167 13.0074 17.7079 12.9962 16.9055C12.9962 16.7749 12.9962 16.6443 12.9962 16.4912C12.5035 16.4912 12.037 16.4912 11.5705 16.4912C10.6561 16.4912 10.0067 15.853 9.9955 14.9349C9.9955 14.6475 9.99177 14.3564 9.9955 14.069C9.99923 13.7145 10.2008 13.4905 10.5068 13.4943C10.8091 13.4943 11.0032 13.7182 11.0069 14.0802C11.0107 14.3751 11.0069 14.6737 11.0069 14.9722C11.0107 15.2708 11.1786 15.4798 11.466 15.491C11.9624 15.5097 12.4625 15.4947 12.9925 15.4947V15.2036C12.9925 12.8934 12.9999 10.5794 12.9887 8.26918C12.9887 7.70189 14.5935 7.25776 15.1458 6.99277H13.6867Z",
    fill: "url(#paint0_linear_1150_13468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01079 10.3971C9.01079 9.92683 9.01079 9.48643 9.01079 9.0423C9.01079 8.78478 8.95854 8.55338 8.70102 8.44141C8.43976 8.32572 8.23822 8.44888 8.05534 8.63549C7.45072 9.24384 6.84237 9.84846 6.23776 10.4568C5.92052 10.774 5.92425 11.0204 6.23776 11.3413C6.84237 11.9497 7.45072 12.5543 8.05908 13.1627C8.23449 13.3381 8.4211 13.4612 8.68235 13.3605C8.95107 13.256 9.01452 13.032 9.01079 12.7745C9.01079 12.3229 9.01079 11.8713 9.01079 11.3936C9.24219 11.3936 9.45119 11.3936 9.66019 11.3936C10.1043 11.3936 10.5485 11.3973 10.9926 11.3936C11.2986 11.3824 11.5039 11.1734 11.5039 10.8935C11.5039 10.6173 11.2874 10.4008 10.9926 10.3971C10.3469 10.3934 9.69752 10.3971 9.01452 10.3971H9.01079Z",
    fill: "url(#paint1_linear_1150_13468)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1150_13468",
    x1: 13.9937,
    y1: 6,
    x2: 13.9937,
    y2: 17.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1150_13468",
    x1: 8.75257,
    y1: 8.39648,
    x2: 8.75257,
    y2: 13.3967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificCheckout);
export default __webpack_public_path__ + "static/media/notific_checkout.918eb0de2b4da48120ac1369759a7388.svg";
export { ForwardRef as ReactComponent };